import axios from "axios";

// Единая ось для запросов к новому gateway (gateway2). cookie-based auth,
// поэтому withCredentials. baseURL без хвостового слеша, чтобы пути
// "/projects/...", "/sources/internal/..." собирались корректно.
const NEW_API = (process.env.VUE_APP_NEW_API || "/api/").replace(/\/$/, "");

export const http = axios.create({
    baseURL: NEW_API,
    withCredentials: true,
});

export const mergePatchConfig = {
    headers: { "Content-Type": "application/merge-patch+json" },
    transformRequest: [(d) => d],
};

export function buildQuery(params = {}) {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "") return;
        if (Array.isArray(v)) v.forEach((x) => usp.append(k, x));
        else usp.append(k, v);
    });
    const s = usp.toString();
    return s ? `?${s}` : "";
}
